// extracted by mini-css-extract-plugin
export default {"wrapper":"StrategyTemplateDetail_wrapper__AbQbg"};